// ArrayBuffer 转 Base64 工具函数
export const arrayBufferToBase64 = (buffer) => {
  // 确保输入是 ArrayBuffer
  if (!(buffer instanceof ArrayBuffer)) {
    throw new Error('Input must be ArrayBuffer');
  }

  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  // 使用 btoa 进行 base64 编码
  return typeof btoa !== 'undefined' ? btoa(binary) : Buffer.from(binary, 'binary').toString('base64');
};

// Blob 转 Base64
export const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

